import AirDatepicker from 'air-datepicker';
import localeEn from 'air-datepicker/locale/en';
// import 'air-datepicker/air-datepicker.css';
import { debounce } from './debounce';


export function manualDatePicker() {

    let dateFields = document.querySelectorAll('[data-manualDateInput]');

    let initialOptions = {
        position: 'bottom center',
        isMobile: isMobile(),
        autoClose: isMobile(),
        selectedDates: [new Date()],
        locale: localeEn,
        timepicker: true,
        timeFormat: 'hh:mm AA'
    }

    let pickers = [];

    dateFields.forEach((field) => {
        // https://air-datepicker.com/ru/docs
        let picker = new AirDatepicker(field.querySelector('input'), initialOptions);
        let btn = field.querySelector('button');
        pickers.push(picker);

        function openDatepicker() {
            if (picker.visible) {
                picker.hide();
            } else {
                picker.show();
            }
        }

        btn.addEventListener('click', openDatepicker);
    })

    function isMobile() {
        if (window.innerWidth >= 1200) {
            return false;
        } else {
            return true;
        }
    }

    function updatePicker() {
        if (isMobile()) {
            pickers.forEach(picker => {
                picker.update({
                    isMobile: true,
                    autoClose: true
                });
            })

        } else {
            pickers.forEach(picker => {
                picker.update({
                    isMobile: false,
                    autoClose: false
                });
            })
        }
    }

    let debouncedUpdate = debounce(updatePicker, 500);

    window.addEventListener('resize', evt => debouncedUpdate());

}
